import React, { useCallback, useState } from "react";
import moment from "moment";
import CustomMenu from "../../../../../../components/Menu";
import RemoveUser from "../RemoveUser";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import { CustomButton } from "../../../../../../components/Button/Button";
import { useCustomSearchParams } from "../../../../../../hooks/useCustomSearchParams";
import { Box } from "@mui/material";

const UsersList = ({
  anchorEl,
  open,
  closeUserList,
  users,
  isColabrotar,
  ownerId,
  filterUserById,
  selectedUsers,
  removeSelectedUser,
  handleRemoveColabrotor,
  setOpenEditUserDialog,
  boardName,
  setDrawerClose,
}) => {
  const isMobile = useResponsive("down", "md");

  const [selectedUserSearch, updateSearchParams, removeSearchParam] =
    useCustomSearchParams("search");

  const [mobileFilterSelectedUser, setMobileFilterSelectedUser] = useState(
    selectedUserSearch?.split(",") || []
  );
  const handleMobileFilterUser =
    //  useCallback(
    (userId) => {
      console.log("userId", userId);

      const userIdString = String(userId);
      if (mobileFilterSelectedUser.includes(userIdString)) {
        setMobileFilterSelectedUser(
          mobileFilterSelectedUser?.filter((id) => id !== userIdString)
        );
      } else {
        setMobileFilterSelectedUser([
          ...mobileFilterSelectedUser,
          userIdString,
        ]);
      }
    };

  const handleApplyMobileFilterUser = useCallback(() => {
    updateSearchParams("search", mobileFilterSelectedUser?.join(","));
    setDrawerClose();
  }, [mobileFilterSelectedUser, updateSearchParams, setDrawerClose]);

  return (
    <>
      {/* {isMobile ? (
        <Box className="users-list-container">
          {(isColabrotar
            ? users
            : users?.sort((a, b) => {
                const dateA = moment(a?.last_seen);
                const dateB = moment(b?.last_seen);
                return dateB - dateA;
              })
          )?.map((user, index) => (
            <React.Fragment key={`board-user-${user?.user_id}-${index}`}>
              <RemoveUser
                key={`board-user-${user?.user_id}-${index}`}
                ownerId={ownerId}
                user={user}
                onClick={() => handleMobileFilterUser(user?.user_id)}
                closeUserList={closeUserList}
                isSelected={mobileFilterSelectedUser?.includes(
                  String(user?.user_id)
                )}
                removeSearchParam={removeSelectedUser}
                isColabrotar={isColabrotar}
                handleRemoveColabrotor={handleRemoveColabrotor}
                setOpenEditUserDialog={setOpenEditUserDialog}
                boardName={boardName}
                boardOwnerId={boardName?.data?.responseData?.owner_user_id}
              />
            </React.Fragment>
          ))}
        </Box>
      ) : ( */}
        <CustomMenu
          id="user-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={closeUserList}
          className="assign-board-owner-list">
          {(isColabrotar
            ? users
            : users?.sort((a, b) => {
                const dateA = moment(a?.last_seen);
                const dateB = moment(b?.last_seen);
                return dateB - dateA;
              })
          )?.map((user, index) => (
            <React.Fragment key={`board-user-${user?.user_id}-${index}`}>
              <RemoveUser
                ownerId={ownerId}
                user={user}
                onClick={() => filterUserById(user?.user_id)}
                closeUserList={closeUserList}
                isSelected={selectedUsers?.includes(String(user?.user_id))}
                removeSearchParam={removeSelectedUser}
                isColabrotar={isColabrotar}
                handleRemoveColabrotor={handleRemoveColabrotor}
                setOpenEditUserDialog={setOpenEditUserDialog}
                boardName={boardName}
                boardOwnerId={boardName?.data?.responseData?.owner_user_id}
              />
            </React.Fragment>
          ))}
        </CustomMenu>
      {/* )} */}
      {/* {isMobile && (
        <CustomButton
          size="small"
          onClick={handleApplyMobileFilterUser}
          // disabled={!mobileFilterSelectedUser?.length}
          className={`capitalize mobile-board-filter-apply-btn`}>
          APPLY
        </CustomButton>
      )} */}
    </>
  );
};

export default UsersList;
